"use strict";
import { createContext, useContext } from "react";
const TableSizeContext = createContext({ width: 0, height: 0, top: 0, left: 0 });
export const useTableSize = () => {
  return useContext(TableSizeContext);
};
export function TableSizeProvider({ children, value }) {
  return <TableSizeContext.Provider value={value}>{children}</TableSizeContext.Provider>;
}
